import { createJsonClient } from '../../shared/httpClient';
import type { NotificationsGateway } from './NotificationsGateway';
import type { NotificationsResponse } from './types';

// Identity is called through the same-origin `/api` prefix (no module prefix).
export class HttpNotificationsGateway implements NotificationsGateway {
  private readonly request = createJsonClient('');

  list(signal?: AbortSignal): Promise<NotificationsResponse> {
    return this.request('/api/notifications', undefined, signal);
  }

  async markRead(id: string): Promise<void> {
    await this.request<unknown>(`/api/notifications/${encodeURIComponent(id)}/read`, { method: 'POST', body: JSON.stringify({}) });
  }

  async markAllRead(): Promise<void> {
    await this.request<unknown>('/api/notifications/read-all', { method: 'POST', body: JSON.stringify({}) });
  }
}
